module.exports = __webpack_public_path__ + "img/images_vip_013.f0cef9a8.png";